import React, { ReactNode } from 'react';
import { useParams } from 'react-router';
import { useAsyncState } from 'utils/hooks';
import { getUserDetails } from 'services/users';
import { LinkTab, LoadingIndicator, Tabs } from '@ygtechnologies/bygr-frontend-component-library';
import { BygrUserDetails } from 'types';
import { UserDashboard } from './UserDashboard';
import { UserProjects } from './UserProjects';
import { UserProfiles } from './UserProfiles';
import { UserUnits } from './UserUnits';

export type UserDetailsTab = 'dashboard' | 'profiles' | 'projects' | 'units';
interface TabSettings {
    id: UserDetailsTab;
    name: string;
    render(opts: { user: BygrUserDetails; reload(): void }): ReactNode;
}

const tabs: TabSettings[] = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        render: ({ user, reload }) => <UserDashboard user={user} reload={reload} />,
    },
    {
        id: 'profiles',
        name: 'Profiles',
        render: ({ user, reload }) => <UserProfiles user={user} reload={reload} />,
    },
    {
        id: 'projects',
        name: 'Projects',
        render: ({ user, reload }) => <UserProjects user={user} reload={reload} />,
    },
    {
        id: 'units',
        name: 'Units',
        render: ({ user, reload }) => <UserUnits user={user} reload={reload} />,
    },
];

export interface UserDetailsProps {}

export const UserDetails: React.FC<UserDetailsProps> = () => {
    const { userId, tab } = useParams<{ userId: string; tab: UserDetailsTab }>();
    const [user, , reload] = useAsyncState(() => getUserDetails(+userId), [userId], null);

    if (!user) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <h3>User {user?.displayName ?? user?.email}</h3>
            <Tabs activeTabId={tab}>
                {tabs.map((tab) => (
                    <LinkTab key={tab.id} id={tab.id} name={tab.name} to={`/users/${user.id}/${tab.id}`}>
                        <div>{tab.render({ user: user, reload: reload })}</div>
                    </LinkTab>
                ))}
            </Tabs>
        </div>
    );
};
